<template>
  <div class="card">
    <!--begin::Body-->
    <div class="card-body">
      <!--begin::Heading-->
      <div class="text-center">
        <!--begin::Title-->
        <span style="text-muted">{{
          $t('account.customerRepresentative')
        }}</span>
        <h2>{{ $t('account.customerRepresentativeName') }}</h2>
        <!--end::Title-->
        <!--begin::Image-->
        <div class="py-7 text-center">
          <img
            class="img-fluid rounded"
            src="/image/customer-agent.svg"
            alt="Dilara Ödemiş"
          />
        </div>
        <!--end::Image-->
      </div>
      <!--end::Heading-->
      <!--begin::Links-->
      <div class="text-center mb-1">
        <!--begin::Link-->
        <a class="btn btn-primary rounded-sm" v-b-modal.customer-agent-modal>{{
          $t('account.contactMe')
        }}</a>
        <!--end::Link-->
      </div>
      <!--end::Links-->
    </div>
    <!--end::Body-->
    <CustomerAgentModal :user="user" />
  </div>
</template>

<script>
export default {
  name: 'Agent',
  props: {
    user: Array | String,
  },
  methods: {
    // openModal() {
    //   this.$bvModal.show('customer-agent-modal')
    // },
  },
  components: {
    CustomerAgentModal: () =>
      import('@/components/account/modals/CustomerAgentModal'),
  },
}
</script>
